import axios from "@/lib/axios";

const searchTerminateCancel = (status: string, facilityId: number | undefined) => {
  return axios.get(`/facility/facility_agreements/terminate_cancels/search?status=${status}&facility_id=${facilityId}`);
}

export default searchTerminateCancel;